import { TrashIcon } from '@heroicons/react/24/outline'

import { Button, Tooltip, useModalConfirm } from '@repo/ui'

import { trackEvent } from 'global-utils/Analytics'
import System from 'system'
import { useMutate } from 'utils'

import { NOTIFICATIONS_STATUS } from 'notifications/src'

import type { FC } from 'react'

interface DeleteRoundButtonProps {
  disabled?: boolean
  roundId: string
}

export const DeleteRoundButton: FC<DeleteRoundButtonProps> = ({ disabled = false, roundId }) => {
  const [ModalConfirm, confirmDelete] = useModalConfirm()

  const deleteReport = useMutate(
    () => ({
      method: 'delete',
      url: `sports/soccer/stages/round/${roundId}`,
    }),
    { invalidate: [['stages'], ['rounds', roundId]] },
  )

  const onDelete = async () => {
    try {
      if (await confirmDelete()) {
        trackEvent('Round', 'Delete', 'Event')
        await deleteReport.mutateAsync()
      }
    } catch (error: unknown) {
      System.addNotification({
        id: roundId,
        // @ts-expect-error response not defined
        children: error?.response?.data?.message || 'No se ha eliminar la ronda',
        dismissAfter: 10000,
        status: NOTIFICATIONS_STATUS.ERROR,
        title: 'Eliminación de ronda',
      })
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }
  }

  return (
    <>
      <Tooltip content="Eliminar la ronda" on={['hover', 'focus']}>
        <Button asIcon className="text-red" disabled={disabled} onClick={onDelete}>
          <TrashIcon className="size-4" />
        </Button>
      </Tooltip>
      <ModalConfirm accent="red" header="Eliminar reporte">
        ¿Confirmas eliminar la ronda seleccionada?
        <div className="text-greyDark">Esta acción es irreversible; no se puede deshacer.</div>
      </ModalConfirm>
    </>
  )
}
